import {
    GET_ALL_SEGMENTS_PENDING,
    GET_ALL_SEGMENTS_FULFILLED,
    GET_ALL_SEGMENTS_REJECTED,
    GET_SEGMENTS_PENDING,
    GET_SEGMENTS_FULFILLED,
    GET_SEGMENTS_REJECTED,
    GET_SEGMENT_PENDING,
    GET_SEGMENT_FULFILLED,
    GET_SEGMENT_REJECTED,
    DELETE_SEGMENT_FULFILLED,
    DELETE_SEGMENT_PENDING,
    DELETE_SEGMENT_REJECTED,
    CREATE_SEGMENT_FULFILLED,
    CREATE_SEGMENT_PENDING,
    CREATE_SEGMENT_REJECTED,
    ADD_EQUIPMENT_TO_SEGMENT_PENDING,
    ADD_EQUIPMENT_TO_SEGMENT_FULFILLED,
    ADD_EQUIPMENT_TO_SEGMENT_REJECTED,
    REMOVE_EQUIPMENT_FROM_SEGMENT_PENDING,
    REMOVE_EQUIPMENT_FROM_SEGMENT_FULFILLED,
    REMOVE_EQUIPMENT_FROM_SEGMENT_REJECTED,
    ADD_PRODUCT_TO_SEGMENT_PENDING,
    ADD_PRODUCT_TO_SEGMENT_FULFILLED,
    ADD_PRODUCT_TO_SEGMENT_REJECTED,
    REMOVE_PRODUCT_FROM_SEGMENT_PENDING,
    REMOVE_PRODUCT_FROM_SEGMENT_FULFILLED,
    REMOVE_PRODUCT_FROM_SEGMENT_REJECTED
} from '../actions/SegmentActions';

// INITIALIZE STATE
const initialState = {
    allSegments: [],
    segments: [],
    segment: {},
    fetchingAllSegments: false,
    fetchedAllSegments: false,
    failedAllSegments: false,
    fetchingSegments: false,
    fetchedSegments: false,
    failedSegments: false,
    fetchingSegment: false,
    fetchedSegment: false,
    failedSegment: false,
    updatingSegment: false,
    updatedSegment: false,
    creatingSegment: false,
    createdSegment: false,
    addingEquipmentToSegment: false,
    addedEquipmentToSegment: false,
    addEquipmentToSegmentFailed: false,
    removingEquipmentFromSegment: false,
    removedEquipmentFromSegment: false,
    removeEquipmentFromSegmentFailed: false,
    addingProductToSegment: false,
    addedProductToSegment: false,
    addProductToSegmentFailed: false,
    removingProductFromSegment: false,
    removedProductFromSegment: false,
    removeProductFromSegmentFailed: false
};

export const SegmentReducer = (state = initialState, action ) => {
    switch(action.type) {
        case GET_ALL_SEGMENTS_PENDING:
            return {
                ...state,
                fetchingAllSegments: true,
                fetchedAllSegments: false,
                failedAllSegments: false
            };
        case GET_ALL_SEGMENTS_FULFILLED:
            return {
                ...state,
                allSegments: action.payload,
                fetchingAllSegments: false,
                fetchedAllSegments: true,
                failedAllSegments: false
            };
        case GET_ALL_SEGMENTS_REJECTED:
            return {
                ...state,
                fetchingAllSegments: false,
                fetchedAllSegments: false,
                failedAllSegments: true
            };
        case GET_SEGMENTS_PENDING:
            return {
                ...state,
                segments: [],
                fetchingSegments: true,
                fetchedSegments: false,
                failedSegments: false
            };
        case GET_SEGMENTS_FULFILLED:
            return {
                ...state,
                segments: action.payload,
                fetchingSegments: false,
                fetchedSegments: true,
                failedSegments: false
            };
        case GET_SEGMENTS_REJECTED:
            return {
                ...state,
                fetchingSegments: false,
                fetchedSegments: false,
                failedSegments: true
            };
        case GET_SEGMENT_PENDING:
            return {
                ...state,
                segment: {},
                fetchingSegment: true,
                fetchedSegment: false,
                failedSegment: false
            };
        case GET_SEGMENT_FULFILLED:
            return {
                ...state,
                segment: action.payload,
                fetchingSegment: false,
                fetchedSegment: true,
                failedSegment: false
            };
        case GET_SEGMENT_REJECTED:
            return {
                ...state,
                fetchingSegment: false,
                fetchedSegment: false,
                failedSegment: true
            };
        case DELETE_SEGMENT_FULFILLED: {
            let segments = state.segments.filter(function (i) {
                return i.id !== action.payload;
            });

            let allSegments = state.allSegments.filter(function (i) {
                return i.id !== action.payload;
            });

            return {
                ...state,
                allSegments: allSegments,
                segments: segments,
                updating: false,
                updated: true
            };
        }
        case DELETE_SEGMENT_PENDING:
            return {
                ...state,
                updating: true,
                updated: false
            };
        case DELETE_SEGMENT_REJECTED:
            return {
                ...state,
                failed: true,
                updating: false,
                updated: false
            };
        case CREATE_SEGMENT_FULFILLED: {
            return {
                ...state,
                creating: false,
                created: true
            };
        }
        case CREATE_SEGMENT_PENDING:
            return {
                ...state,
                creating: true,
                created: false
            };
        case CREATE_SEGMENT_REJECTED:
            return {
                ...state,
                failed: true,
            };
        case ADD_EQUIPMENT_TO_SEGMENT_PENDING: {
            return {
                ...state,
                addingEquipmentToSegment: true,
                addedEquipmentToSegment: false,
                addEquipmentToSegmentFailed: false
            };
        }
        case ADD_EQUIPMENT_TO_SEGMENT_FULFILLED:
            return {
                ...state,
                addingEquipmentToSegment: false,
                addedEquipmentToSegment: true,
                addEquipmentToSegmentFailed: false
            };
        case ADD_EQUIPMENT_TO_SEGMENT_REJECTED:
            return {
                ...state,
                addingEquipmentToSegment: false,
                addedEquipmentToSegment: false,
                addEquipmentToSegmentFailed: true
            };
        case REMOVE_EQUIPMENT_FROM_SEGMENT_PENDING: {
            return {
                ...state,
                removingEquipmentFromSegment: true,
                removedEquipmentFromSegment: false,
                removeEquipmentFromSegmentFailed: false
            };
        }
        case REMOVE_EQUIPMENT_FROM_SEGMENT_FULFILLED:{
            let segments = state.segments.filter(function (i) {
                return i.id !== action.payload.segmentId;
            });
            return {
                ...state,
                segments: segments,
                removingEquipmentFromSegment: false,
                removedEquipmentFromSegment: true,
                removeEquipmentFromSegmentFailed: false
            };
        }
            
        case REMOVE_EQUIPMENT_FROM_SEGMENT_REJECTED:
            return {
                ...state,
                removingEquipmentFromSegment: false,
                removedEquipmentFromSegment: false,
                removeEquipmentFromSegmentFailed: true
            };
        case ADD_PRODUCT_TO_SEGMENT_PENDING:
            return {
                ...state,
                addingProductToSegment: true,
                addedProductToSegment: false,
                addProductToSegmentFailed: false
            };
        case ADD_PRODUCT_TO_SEGMENT_FULFILLED:
            return {
                ...state,
                addingProductToSegment: false,
                addedProductToSegment: true,
                addProductToSegmentFailed: false
            };
        case ADD_PRODUCT_TO_SEGMENT_REJECTED:
            return {
                ...state,
                addingProductToSegment: false,
                addedProductToSegment: false,
                addProductToSegmentFailed: true
            };
        case REMOVE_PRODUCT_FROM_SEGMENT_PENDING:
            return {
                ...state,
                removingProductFromSegment: true,
                removedProductFromSegment: false,
                removeProductFromSegmentFailed: false
            };
        case REMOVE_PRODUCT_FROM_SEGMENT_FULFILLED: {
            let segments = state.segments.filter(function (i) {
                return i.id !== action.payload.segmentId;
            });
            return {
                ...state,
                segments: segments,
                removingProductFromSegment: false,
                removedProductFromSegment: true,
                removeProductFromSegmentFailed: false
            };
        }
        case REMOVE_PRODUCT_FROM_SEGMENT_REJECTED:
            return {
                ...state,
                removingProductFromSegment: false,
                removedProductFromSegment: false,
                removeProductFromSegmentFailed: true
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/components/state/reducers/SegmentReducer.js